export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28')
];

export const server_loads = [0];

export const dictionary = {
		"/[lang]": [3],
		"/[lang]/admin": [4,[2]],
		"/[lang]/admin/categories": [5,[2]],
		"/[lang]/admin/categories/[category_id]": [6,[2]],
		"/[lang]/admin/news": [7,[2]],
		"/[lang]/admin/news/[article_id]": [8,[2]],
		"/[lang]/admin/shop": [9,[2]],
		"/[lang]/admin/shop/products/[product_id]": [10,[2]],
		"/[lang]/cart": [11],
		"/[lang]/cart/order": [12],
		"/[lang]/donate-in-game": [14],
		"/[lang]/donate": [13],
		"/[lang]/game-purchase": [15],
		"/[lang]/gang-land": [16],
		"/[lang]/how-to-play": [17],
		"/[lang]/how-to-play/step-1": [18],
		"/[lang]/how-to-play/step-2": [19],
		"/[lang]/news": [20],
		"/[lang]/news/[article_id]": [21],
		"/[lang]/policy-return": [22],
		"/[lang]/privacy-policy": [23],
		"/[lang]/rp": [24],
		"/[lang]/shop": [25],
		"/[lang]/shop/products/[product_id]": [26],
		"/[lang]/user-agreement-in-game": [28],
		"/[lang]/user-agreement": [27]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';